<template>
  <div>
    <img
        :src="require(`../../../../assets/images/error@2x.jpg`)"
        :srcset="`${require(`../../../../assets/images/error@1x.jpg`)} 1x, ${require(`../../../../assets/images/error@2x.jpg`)} 2x, ${require(`../../../../assets/images/error@3x.jpg`)} 3x, ${require(`../../../../assets/images/error@4x.jpg`)} 4x`"
    />

    <div class="modal-body">
      <h2>{{ translate('Timeout') }}</h2>
      <p>{{ translate('We\'re sorry, but your creation has exceeded the processing time. ') }}</p>
      <p>
        <strong>{{ translate('No Credit has been deducted.') }}</strong>
      </p>
      <p>
        {{ translate('Please try again later.') }}
      </p>
    </div>
  </div>
</template>
<script>
import store from '../../../../mixins/store.mixin';

export default {
  name: 'MaxExecTimeReachedError',
  props: {},
  components: {},
  mixins: [store],
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
